import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const PAYMENT_METHODS = ['VISA', 'Mastercard', 'American Express', 'Cabal', 'y más'];
export function OfferSection() {
  return <section id="offer" className="bg-gradient-hero py-20 md:py-28 px-4 md:px-8 relative overflow-hidden" data-id="element-173">
      {/* Decorative Gold Blob — softened */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/[0.06] blur-[120px] rounded-full pointer-events-none" data-id="element-174" />

      <div className="max-w-md mx-auto relative z-10" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="card-premium !border-gold/25 px-7 py-12 md:px-10 md:py-14 shadow-gold text-center space-y-8" data-id="element-176">
          {/* Eyebrow */}
          <p className="uppercase tracking-[0.28em] font-semibold text-[#C8A870] text-[14px]" data-id="element-177">
            Acceso completo al Protocolo H.E.R.
          </p>

          {/* Precio ancla */}
          <p className="text-foreground/35 font-body font-medium line-through decoration-foreground/20 decoration-1 text-[20px]" data-id="element-178">
            $44.000 ARS
          </p>

          {/* HOY */}
          <p className="uppercase tracking-[0.24em] text-foreground/60 font-semibold -mt-2 text-[14px]" data-id="element-179">
            Hoy
          </p>

          {/* Precio actual */}
          <div className="space-y-2" data-id="element-180">
            <p className="text-6xl md:text-7xl font-display font-semibold text-gradient-gold leading-none" data-id="element-181">
              $12.000
            </p>
            <p className="font-body text-[14px] text-foreground/50 tracking-wide" data-id="element-182">
              ARS · pago único
            </p>
          </div>

          {/* Cuotas */}
          <p className="font-body md:text-[16px] text-[#C8A870] text-[17px]" data-id="element-183">
            O en <span className="font-semibold" data-id="element-184">3 cuotas de $4.000</span> con
            Mercado Pago
          </p>

          {/* Frase emocional */}
          <p className="font-display italic md:text-[18px] max-w-xs mx-auto text-[#F0E8D8] text-[18px]" data-id="element-185">
            Menos que una consulta nutricional. Acceso de por vida a H.E.R.
          </p>

          {/* Precio de lanzamiento */}
          <p className="font-body tracking-wide text-[#C8A870] text-[14px]" data-id="element-186">
            📩 Acceso inmediato. Recibís el Protocolo H.E.R. por email apenas se
            aprueba el pago.
          </p>

          {/* CTA */}
          <div className="pt-2" data-id="element-187">
            <CTAButton section="offer" className="w-full text-[16px] md:text-[17px]" data-id="element-188">
              Acceder al Protocolo H.E.R.
            </CTAButton>
          </div>

          {/* Trust block — Compra protegida */}
          <div className="space-y-6 pt-2" data-id="element-189">
            {/* Compra protegida card */}
            <div className="rounded-[6px] border-[0.5px] border-gold/20 bg-white/[0.02] p-5 md:p-6 flex items-center gap-4 md:gap-5 text-left" data-id="element-190">
              {/* Mercado Pago wordmark */}
              <div className="flex-shrink-0 leading-[1.05]" data-id="element-191">
                <span className="block font-body font-semibold text-[18px] md:text-[20px] text-[#F0E8D8]" data-id="element-192">
                  mercado
                </span>
                <span className="block font-body font-semibold text-[18px] md:text-[20px] text-[#3483FA]" data-id="element-193">
                  pago
                </span>
              </div>

              {/* Vertical divider */}
              <div className="w-px self-stretch bg-gold/25" data-id="element-194" />

              {/* Copy */}
              <div className="flex-1 space-y-1.5" data-id="element-195">
                <div className="flex items-center gap-2" data-id="element-196">
                  <ShieldCheckIcon className="w-4 h-4 text-[#C8A870] flex-shrink-0" data-id="element-197" />
                  <span className="uppercase tracking-[0.18em] text-[11px] font-semibold text-[#C8A870]" data-id="element-198">
                    Compra protegida
                  </span>
                </div>
                <p className="font-body text-[15px] md:text-[16px] text-[#F0E8D8] leading-snug" data-id="element-199">
                  Pago seguro mediante Mercado Pago.
                </p>
                <p className="font-body text-[13px] text-foreground/55 leading-snug" data-id="element-200">
                  Protegido con los estándares de seguridad de{' '}
                  <span className="text-[#C8A870]" data-id="element-201">Mercado Pago</span>.
                </p>
              </div>
            </div>

            {/* Podés pagar con */}
            <div className="space-y-4" data-id="element-202">
              <div className="flex items-center gap-3" data-id="element-203">
                <div className="flex-1 h-px bg-gold/15" data-id="element-204" />
                <span className="uppercase tracking-[0.2em] text-[11px] font-semibold text-foreground/45 flex-shrink-0" data-id="element-205">
                  Podés pagar con
                </span>
                <div className="flex-1 h-px bg-gold/15" data-id="element-206" />
              </div>

              <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-207">
                {PAYMENT_METHODS.map(method => <span key={method} className="inline-flex items-center justify-center rounded-[4px] border-[0.5px] border-gold/15 bg-white/[0.03] px-3 py-2 font-body font-semibold text-[12px] tracking-wide text-foreground/75" data-id="element-208">
                    {method}
                  </span>)}
              </div>
            </div>

            {/* Compra 100% protegida */}
            <div className="flex items-center justify-center gap-3 pt-1" data-id="element-209">
              <ShieldCheckIcon className="w-4 h-4 text-[#C8A870] flex-shrink-0" data-id="element-210" />
              <span className="uppercase tracking-[0.16em] text-[11px] font-semibold text-foreground/60" data-id="element-211">
                Compra 100% protegida
              </span>
              <div className="w-px h-4 bg-gold/25" data-id="element-212" />
              <span className="font-body font-semibold text-[13px] leading-none" data-id="element-213">
                <span className="text-[#F0E8D8]" data-id="element-214">mercado</span>
                <span className="text-[#3483FA]" data-id="element-215">pago</span>
              </span>
            </div>
          </div>

          {/* Divider */}

          {/* Garantía */}
          <div className="space-y-3 pt-4" data-id="element-216">
            <p className="uppercase tracking-[0.22em] text-[#C8A870] font-semibold text-[14px]" data-id="element-217">
              ✦ Garantía de 30 días
            </p>
            <p className="font-body md:text-[15px] max-w-sm mx-auto text-[#F0E8D8] text-[15px]" data-id="element-218">
              Probalo durante 30 días. Si H.E.R. no es para vos, te devolvemos
              el 100% de tu dinero.
            </p>
          </div>

          {/* Footer */}
          <p className="text-[13px] font-body pt-4 text-[#F0E8D8]" data-id="element-219">
            🔒 Pago seguro con{' '}
            <span className="font-semibold" data-id="element-220">Mercado Pago</span>
          </p>
        </motion.div>
      </div>
    </section>;
}